export const AskAI = 'https://cdn.speechify.com/web/animations/upsells/global-cards/AskAI.json';
export const CloneVoice = 'https://cdn.speechify.com/web/animations/upsells/global-cards/CloneVoice.json';
export const DownloadMP3 = 'https://cdn.speechify.com/web/animations/upsells/global-cards/DownloadMP3.json';
export const FileFormats = 'https://cdn.speechify.com/web/animations/upsells/global-cards/FileFormats.json';
export const PremiumVoices = 'https://cdn.speechify.com/web/animations/upsells/global-cards/PremiumVoices.json';
export const Scan = 'https://cdn.speechify.com/web/animations/upsells/global-cards/Scan.json';
export const Skip = 'https://cdn.speechify.com/web/animations/upsells/global-cards/Skip.json';
export const Speed = 'https://cdn.speechify.com/web/animations/upsells/global-cards/Speed.json';
export const Support = 'https://cdn.speechify.com/web/animations/upsells/global-cards/Support.json';
export const UnlimitedFiles = 'https://cdn.speechify.com/web/animations/upsells/global-cards/UnlimitedFiles.json';

export const ALL_GLOBAL_UPSELL_MODAL_ANIMATION_ASSET_PATHS = [
  AskAI,
  CloneVoice,
  DownloadMP3,
  FileFormats,
  PremiumVoices,
  Scan,
  Skip,
  Speed,
  Support,
  UnlimitedFiles
];
